import { combineReducers } from '@reduxjs/toolkit'
import user from './slice/user'

const reducer = combineReducers({
  user,
})

export default reducer
